import React from 'react';

import { Card, CardBody, CardCoverPhoto } from '@react/react-spectrum/Card';

export default function TargetCard({ imsOrg }) {
  return (
    <Card allowsSelection={false}>
      <CardCoverPhoto src={getSolutionImage(imsOrg.name)} />
      <CardBody title={imsOrg.targetClientCode} subtitle="Target" />
    </Card>
  );
}

function getSolutionImage(name) {
  let number = (name.length % 4) + 1;

  return `https://demo-system-dashboard.s3.eu-north-1.amazonaws.com/images/marketing-${number}.jpg`;
}
